import { useContext } from "react";
import userContext from "./context.js";
import { useState } from "react";
import { Button } from "react-bootstrap";
import { Card } from "react-bootstrap";
export default function Deposit() {
  let user = useContext(userContext);
  let len=user.users.length
  let [currbalance, setCurrbalance] = useState(user.users[len-1].balance);
  let [deposit, setDeposit] = useState(0);

  function handleSubmit(e) {
    e.preventDefault();
    // console.log("deposit", deposit);
    if(deposit>0 && deposit){
    alert(`₹${deposit} Deposit Successfully`)
    setCurrbalance(Number(currbalance) + Number(deposit));
  }else{
    alert("please Enter a valid amount")
  }
}
  user.users[len - 1].balance = currbalance;
  return (
    <div id="deposit">
      <Card id="form-card">
      <form onSubmit={handleSubmit}>
        <h1>Deposit </h1><br />
      <h3>Available Balance : {currbalance} </h3><br />
        <input type="number" onChange={(e) => setDeposit(e.target.value)} />
        <Button type="submit" disabled={!(deposit)}><b>Submit</b></Button>
      </form>
      </Card>
    </div>
  );
}

